import { Box, Typography } from '@mui/material';
import { memo } from 'react';

interface CountPillProps {
  count: number;
}

function CountPill({ count }: CountPillProps) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 24,
        height: 22,
        px: 1,
        borderRadius: '9999px',
        backgroundColor: 'background.default',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.primary', lineHeight: 1 }}>
        {count}
      </Typography>
    </Box>
  );
}

export default memo(CountPill);
